import {
  CurrencySwitcher
} from "./chunk-OHAXPSQO.mjs";

// src/CurrencySwitcherModal/CurrencySwitcherModal.tsx
import { Modal, ModalOverlay, ModalHeader, ModalContent, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var CurrencySwitcherModal = ({
  heading,
  onItemClick,
  currencies,
  selectedCurrency,
  onClose,
  isOpen,
  onOpen,
  render
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    render ? render(onOpen) : null,
    /* @__PURE__ */ jsxs(Modal, { "data-testid": "currency-switcher-modal", isOpen, onClose, size: "4xl", isCentered: false, children: [
      /* @__PURE__ */ jsx(ModalOverlay, {}),
      /* @__PURE__ */ jsxs(
        ModalContent,
        {
          overflow: "hidden",
          "data-testid": "currency-switcher-modal-content",
          maxHeight: "calc(100dvh - var(--chakra-space-8))",
          maxW: { base: "unset", md: "fit-content" },
          children: [
            /* @__PURE__ */ jsx(ModalHeader, { lineHeight: 6, children: heading }),
            /* @__PURE__ */ jsx(
              ModalCloseButton,
              {
                "data-testid": "modal-close-button",
                borderRadius: "sm",
                boxSize: 2,
                sx: {
                  svg: { boxSize: 2.5 },
                  _hover: { backgroundColor: "primary.200" },
                  _active: {
                    backgroundColor: "primary.800",
                    color: "greyscale.200"
                  }
                }
              }
            ),
            /* @__PURE__ */ jsx(ModalBody, { pb: 0, pr: "2 !important", mr: { base: 4, md: 8 }, mb: { base: 4, md: 8 }, overflowX: "hidden", children: /* @__PURE__ */ jsx(
              CurrencySwitcher,
              {
                render,
                onItemClick,
                selectedCurrency,
                currencies
              }
            ) })
          ]
        }
      )
    ] })
  ] });
};

export {
  CurrencySwitcherModal
};
